export const REVIEW_SCORE_COUNT = 5;
